export default __webpack_public_path__ + "static/media/layerLeft1.1afa406e.webp";